import { Action } from "@ngrx/store";
import { ChapterViewState } from "./chapter-view.model";

export enum ChapterViewActionTypes {
  ChapterShow = "ChapterShow",
  ChapterFinalShow = "ChapterFinalShow",
  ChapterQuizzesIncomplete = "ChapterQuizzesIncomplete",
  ChapterUpdate = "ChapterUpdate",
}

export class ChapterShowAction implements Action {
  readonly type = ChapterViewActionTypes.ChapterShow;
  constructor(public payload: ChapterViewState) { }
}

export class ChapterUpdateAction implements Action {
  readonly type = ChapterViewActionTypes.ChapterUpdate;
  constructor(public payload: ChapterViewState) { }
}

export class ChapterFinalShowAction implements Action {
  readonly type = ChapterViewActionTypes.ChapterFinalShow;
  constructor(public payload: ChapterViewState) { }
}

export class ChapterQuizzesIncompleteAction implements Action {
  readonly type = ChapterViewActionTypes.ChapterQuizzesIncomplete;
  constructor(public payload: ChapterViewState) { }
}

export type ChapterViewActions =
  | ChapterShowAction
  | ChapterFinalShowAction
  | ChapterQuizzesIncompleteAction
  | ChapterUpdateAction;
